<template>
  <div>
    <!-- #region 進階篩選-廣告地區-彈窗 -->
    <v-dialog
      v-model="areaDialog.show"
      scrollable
      width="500px"
      @click:outside="CloseAreaDialog()"
    >
      <v-card>
        <!-- header -->
        <v-card-title class="px-4">
          <div class="font-weight-black">
            {{ areaDialog.title }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseAreaDialog()">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <!-- body -->
        <v-card-text style="height: 400px" class="pa-0">
          <v-tabs-items v-model="tab" ref="tabs">
            <!-- #region 縣市 -->
            <v-tab-item>
              <div class="px-4 mt-5 black--text font-weight-black">
                {{ areaDialog.sub }}
              </div>
              <!-- #region 搜尋可多選 -->
              <template v-if="searchMod">
                <div v-for="x in areaDialog.datas" :key="x.id">
                  <div
                    class="d-flex justify-between align-center"
                    style="cursor: pointer"
                    @click="SwitchItmes(x.id)"
                  >
                    <v-checkbox
                      v-model="areaDialog.temporarySelected"
                      :label="x.name"
                      :value="x"
                      class="mx-4 my-3 py-0"
                      @change="SelectArea($event, x.id)"
                      hide-details
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-badge
                      v-if="SelectedCount(x.id) > 0"
                      color="red accent-2"
                      :content="SelectedCount(x.id)"
                      left
                      inline
                    >
                    </v-badge>

                    <v-btn small icon class="mr-2"
                      ><v-icon dense> mdi-chevron-right</v-icon></v-btn
                    >
                  </div>
                  <v-divider />
                </div>
              </template>
              <!-- #endregion -->

              <!-- #region 申請廣告單選 -->
              <template v-else>
                <v-radio-group
                  v-model="areaDialog.temporarySelected"
                  class="ma-0"
                >
                  <div v-for="x in areaDialog.distDatas" :key="x.id">
                    <div
                      class="d-flex justify-between align-center"
                      style="cursor: pointer"
                      @click="SwitchItmes(x.id)"
                    >
                      <div
                        class="ml-4 my-3 py-0"
                        :class="
                          SelectedDistName(x)
                            ? 'primary--text font-weight-black'
                            : ''
                        "
                      >
                        {{ x.name }}
                      </div>
                      <!-- <v-radio
                        :label="x.name"
                        :value="x.id"
                        class="ml-4 my-3 py-0"
                        hide-details
                        readonly
                      >
                      </v-radio> -->
                      <v-spacer></v-spacer>
                      <div
                        class="mx-2 primary--text font-weight-black"
                        v-if="SelectedDistName(x)"
                      >
                        {{ SelectedDistName(x) }}
                      </div>
                      <v-btn small icon class="mr-2"
                        ><v-icon dense> mdi-chevron-right</v-icon></v-btn
                      >
                    </div>
                    <v-divider />
                  </div>
                </v-radio-group>
              </template>
              <!-- #endregion -->
            </v-tab-item>
            <!-- #endreigon -->
            <!-- #region 行政區 -->
            <v-tab-item>
              <div
                class="grey lighten-5 text-body-1 pa-3 text--primary"
                style="cursor: pointer"
                @click="tab = 0"
              >
                <v-icon color="grey darken-1" class="mr-3"
                  >mdi-chevron-left</v-icon
                >{{ nowDist.name }}
              </div>

              <template v-if="searchMod">
                <div v-for="x in nowDist.dists" :key="x.id">
                  <v-checkbox
                    v-model="tempDist"
                    :label="x.name"
                    :value="x"
                    class="ml-8 my-3 py-0"
                    hide-details
                    @change="ListenTempData()"
                  ></v-checkbox>
                  <v-divider />
                </div>
              </template>
              <template v-else>
                <v-radio-group v-model="tempDist" class="ma-0">
                  <div v-for="x in nowDist.dists" :key="x.id">
                    <v-radio
                      :label="x.name"
                      :value="x.id"
                      class="ml-8 my-3 py-0"
                      hide-details
                      @change="ListenRadio(x.id)"
                    >
                    </v-radio>
                    <v-divider />
                  </div>
                </v-radio-group>
              </template>
            </v-tab-item>

            <!-- #endreigon -->
          </v-tabs-items>
        </v-card-text>
        <!-- footer -->
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn color="" text @click="AreaSelectedClear()">
            {{ areaDialog.clear }}
          </v-btn>
          <v-btn color="primary" @click="ConfirmAreaSelected()">
            {{ areaDialog.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import { Advertise_Get_Area, Advertise_Get_Dist } from "@/apis/api";

export default {
  props: {
    open: Boolean,
    clear: Boolean,
    originList: Array,
    searchMod: Boolean,
  },
  data() {
    return {
      areaDialog: {
        show: false,
        title: "選擇廣告地區",
        sub: "地區列表",
        clear: "清除",
        confirm: "選擇完成",
        datas: [],
        distDatas: [],
        selected: [],
        radioSelected: null,
        temporarySelected: [],
      },
      nowDist: [],
      tempDist: [],
      tempRadio: null,
      tab: 0,
    };
  },
  watch: {
    open() {
      if (this.open) {
        this.OpenAreaDialog();
        if (this.originList) {
          this.tempDist = this.originList;
          if (!this.searchMod) {
            this.tempDist = this.tempRadio = this.originList[0];
          }
          this.IsDistSelected();
        }
      } else {
        setTimeout(() => {
          this.tab = 0;
        }, 500);
      }
    },
    clear() {
      if (this.clear) this.AreaSelectedClear();
    },
    // "areaDialog.temporarySelected"(val) {
    //   let target = this.areaDialog.distDatas.filter((x) => x.id === val.find());
    //   target[0].dists.forEach((x) => {
    //     this.tempDist.push(x);
    //   });
    // 全部跟複選地區則一 陣列處理
    //   if (val.length < 1) return;
    //   let allId = this.areaDialog.datas[0].id;
    //   let lastId = val[val.length - 1];
    //   if (val.length > 1) {
    //     if (lastId === allId) {
    //       this.areaDialog.temporarySelected = [];
    //       this.areaDialog.temporarySelected.push(allId);
    //     } else {
    //       let index = this.areaDialog.temporarySelected.indexOf(allId);
    //       if (index > -1) this.areaDialog.temporarySelected.splice(index, 1);
    //     }
    //   }
    // },
    deep: true,
  },
  mounted() {
    this.Advertise_Get_AreaApi();
    this.Advertise_Get_DistApi();
  },
  methods: {
    //#region Get 行政區 API
    Advertise_Get_DistApi() {
      Advertise_Get_Dist()
        .then((res) => {
          this.areaDialog.distDatas = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion
    //#region Get廣告地區 API
    Advertise_Get_AreaApi() {
      Advertise_Get_Area()
        .then((res) => {
          this.areaDialog.datas = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion

    //#region
    SwitchItmes(areaId) {
      this.tab = 1;
      let target = this.areaDialog.distDatas.filter((x) => x.id === areaId);
      this.nowDist = target[0];
      if (!this.searchMod) this.tempDist = this.tempRadio;
    },
    //#endregion

    //#region
    SelectArea(e, areaId) {
      let isSelected = this.areaDialog.temporarySelected.some(
        (x) => x.id === areaId
      );
      if (isSelected) {
        let filted = this.tempDist.filter((x) => x.areaId !== areaId);
        this.tempDist = filted.concat(
          this.areaDialog.distDatas.filter((x) => x.id === areaId)[0].dists
        );
      } else {
        if (this.tempDist.some((x) => x.areaId === areaId)) {
          this.tempDist = this.tempDist.filter((x) => x.areaId !== areaId);
        }
      }
      this.StopBubbling(e);
    },
    //#endregion

    //#region 開啟地區彈窗
    OpenAreaDialog() {
      // this.areaDialog.temporarySelected = this.areaDialog.selected;
      this.IsDistSelected();
      this.tempDist = this.areaDialog.selected;
      this.areaDialog.show = true;
    },
    //#endregion

    // #region 關閉地區彈窗
    CloseAreaDialog() {
      this.areaDialog.show = false;
      this.$emit("close", true);
      // 延遲顯示 為配合過場動畫
      setTimeout(() => {
        this.AreaSelectedClear();
      }, 300);
    },
    //#endregion

    //#region 清除全部已選
    AreaSelectedClear() {
      this.areaDialog.temporarySelected = [];
      this.areaDialog.selected = [];
      this.tempDist = [];
      this.tempRadio = null;
    },
    //#endregion

    //#region 如已選一個以上的行政區，縣市就顯示勾選
    IsDistSelected() {
      // 直接指向 會ref到address 所以才大費周章的new一個obj來給值
      let orignData = [];
      this.areaDialog.distDatas.forEach((x) => {
        orignData.push({
          id: x.id,
          name: x.name,
          order: x.order,
          dists: null,
          distLen: x.dists.length,
        });
      });

      orignData.forEach((x) => {
        let orignLen = this.originList.filter((y) => x.id === y.areaId).length;
        if (orignLen > 0) {
          if (!this.areaDialog.temporarySelected.some((z) => z.id === x.id)) {
            this.areaDialog.temporarySelected.push({
              id: x.id,
              name: x.name,
              order: x.order,
              dists: null,
            });
          }
        }
      });
    },
    //#endregion

    //#region 確認地區選擇
    ConfirmAreaSelected() {
      if (typeof this.tempDist === "number") {
        this.areaDialog.selected = [];
        this.areaDialog.selected.push(this.tempDist);
      } else if (this.tempDist === undefined) {
        this.areaDialog.selected = [];
      } else {
        this.areaDialog.selected = this.tempDist;
      }

      this.areaDialog.show = false;
      this.$emit("list", this.areaDialog.selected);

      if (this.searchMod) {
        this.$emit("formatList", this.areaSelectedFormat(false));
      } else {
        this.$emit("formatList", this.areaSelectedFormat(true));
      }
    },
    //#endregion

    //#region 地區 Format flag => T:單選 ; F:多選
    areaSelectedFormat(isRadio) {
      let format = [];
      if (isRadio) {
        this.areaDialog.selected.forEach((x) => {
          this.areaDialog.distDatas.forEach((y) => {
            for (let i = 0; i < y.dists.length; i++) {
              if (y.dists[i].id === x) {
                format.push(y.name);
                format.push(y.dists[i].name);
                break;
              }
            }
          });
        });
      } else {
        this.areaDialog.selected.forEach((x) => {
          format.push(x.name);
        });
      }

      return format;
    },
    //#endregion

    //#region 阻止冒泡事件 防止重複點擊操作
    StopBubbling(e) {
      e = window.event || e;
      if (e.stopPropagation) {
        e.stopPropagation(); //阻止事件 冒泡傳播
      } else {
        e.cancelBubble = true; //IE兼容
      }
    },
    //#endregion
    //#region 選擇筆數
    SelectedCount(areaId) {
      if (this.tempDist || this.tempDist.length > 0)
        return this.tempDist.filter((x) => x.areaId === areaId).length;
      return 0;
    },
    //#endregion

    //#region 監聽多選選項點選狀態 (只要有選一個行政區 縣市就顯示勾選)
    ListenTempData() {
      this.areaDialog.distDatas.forEach((x) => {
        if (
          this.tempDist.filter((y) => y.areaId === x.id).length > 0 &&
          !this.areaDialog.temporarySelected.some((z) => z.id === x.id)
        ) {
          console.log(x.id);
          this.areaDialog.temporarySelected.push({
            id: x.id,
            name: x.name,
            order: x.order,
            dists: null,
          });
        }
      });
    },
    //#endregion
    //#region 監聽radio選則
    ListenRadio(id) {
      this.tempRadio = id;
    },
    //#endregion
    //#region 單選縣市的選取狀態
    SelectedDistName(area) {
      let selectdDist = "";
      area.dists.forEach((y) => {
        if (y.id === this.tempRadio) selectdDist = y.name;
      });
      return selectdDist;
    },
  },
};
</script>

<style scoped></style>
